import { render } from "./OsContratadasTrabalhadasChart.vue?vue&type=template&id=f201ac82&scoped=true"
import script from "./OsContratadasTrabalhadasChart.vue?vue&type=script&lang=js"
export * from "./OsContratadasTrabalhadasChart.vue?vue&type=script&lang=js"

import "./OsContratadasTrabalhadasChart.vue?vue&type=style&index=0&id=f201ac82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f201ac82"]])

export default __exports__